if (!customElements.get('recipient-form')) {
	customElements.define('recipient-form', class RecipientForm extends HTMLElement {
		constructor() {
			super();

			this.checkboxInput = this.querySelector(`#Recipient-Checkbox-${ this.dataset.sectionId }`);
			this.checkboxInput.disabled = false;
			this.hiddenControlField = this.querySelector(`#Recipient-Control-${ this.dataset.sectionId }`);
      this.hiddenControlField.disabled = true;
			this.emailInput = this.querySelector(`#Recipient-email-${ this.dataset.sectionId }`);
			this.nameInput = this.querySelector(`#Recipient-name-${ this.dataset.sectionId }`);
      this.messageInput = this.querySelector(`#Recipient-message-${ this.dataset.sectionId }`);
      this.send_onInput = this.querySelector(`#Recipient-send_on-${ this.dataset.sectionId }`);
			this.errorMessageWrapper = this.querySelector('.product-form__recipient-error-message-wrapper');
      this.errorMessageList = this.errorMessageWrapper?.querySelector('ul');
			this.errorMessage = this.errorMessageWrapper?.querySelector('.error-message');
      this.defaultErrorHeader = this.errorMessage?.innerText;
      this.currentProductVariantId = this.dataset.productVariantId;
      this.showCheckboxOnLoad = this.dataset.showCheckbox;
      this.forceAlwaysChecked = this.dataset.forceCheckboxToAlwaysBeChecked;
			this.setSendOnDateLimits();
			this.updateSendOnInputState();
			this.send_onInput?.addEventListener('input', this.updateSendOnInputState.bind(this));
      this.addEventListener('change', this.onChange.bind(this));
		}

		cartUpdateUnsubscriber = undefined;
    variantChangeUnsubscriber = undefined;
    cartErrorUnsubscriber = undefined;

		connectedCallback() {

      this.cartUpdateUnsubscriber = window.FoxThemeEvents.subscribe(`ON_ITEM_ADDED`, response => {
        this.resetRecipientForm();
      })

      this.variantChangeUnsubscriber = window.FoxThemeEvents.subscribe(`${this.productId}__VARIANT_CHANGE`, variant => {
        this.currentProductVariantId = variant.id
      })

      this.cartUpdateUnsubscriber = window.FoxThemeEvents.subscribe(PUB_SUB_EVENTS.cartError, (event) => {
        if (event.source === 'product-form' && event.productVariantId.toString() === this.currentProductVariantId) {
          this.displayErrorMessage(event.message, event.errors);
        }
      });
		}

		disconnectedCallback() {
			if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }

      if (this.variantChangeUnsubscriber) {
        this.variantChangeUnsubscriber();
      }

      if (this.cartErrorUnsubscriber) {
        this.cartErrorUnsubscriber();
      }
		}

		onChange() {
			if (!this.checkboxInput.checked) {
        this.clearInputFields();
        this.clearErrorMessage();
      }
		}

    setSendOnDateLimits() {
			if (!this.send_onInput) return;

			const today = new Date();
			const maximumDate = new Date(today);
			maximumDate.setDate(maximumDate.getDate() + 90);
			this.send_onInput.min = this.formatDate(today);
			this.send_onInput.max = this.formatDate(maximumDate);
		}

		formatDate(date) {
			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, '0');
			const day = String(date.getDate()).padStart(2, '0');
			return `${year}-${month}-${day}`;
		}

		updateSendOnInputState() {
			this.send_onInput?.classList.toggle('has-value', Boolean(this.send_onInput.value));
		}

		displayErrorMessage(title, body) {
      this.clearErrorMessage();
			const errorSize = Object.keys(body).length;
			if (errorSize > 1) this.errorMessageWrapper.hidden = false;
      if (typeof body === 'object') {
        this.errorMessage.innerText = this.defaultErrorHeader;
        return Object.entries(body).forEach(([key, value]) => {
          const errorMessageId = `RecipientForm-${ key }-error-${ this.dataset.sectionId }`
          const fieldSelector = `#Recipient-${ key }-${ this.dataset.sectionId }`;
          const placeholderElement = this.querySelector(`${fieldSelector}`);
          const label = placeholderElement?.getAttribute('placeholder') || key;
          const message = `${label} ${value}`;
          const errorMessageElement = this.querySelector(`#${errorMessageId}`);
          const errorTextElement = errorMessageElement?.querySelector('.error-message')
          if (!errorTextElement) return;

          if (this.errorMessageList) {
            this.errorMessageList.appendChild(this.createErrorListItem(fieldSelector, message));
          }

          errorTextElement.innerText = `${message}.`;
          errorMessageElement.classList.remove('hidden');

          const inputElement = this[`${key}Input`];
          if (!inputElement) return;

          inputElement.setAttribute('aria-invalid', true);
          inputElement.setAttribute('aria-describedby', errorMessageId);
        });
      }

      this.errorMessage.innerText = body;
    }

		createErrorListItem(target, message) {
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.setAttribute('href', target);
      a.innerText = message;
      li.appendChild(a);
      li.className = "error-message";
      return li;
    }

		clearInputFields() {
      this.emailInput.value = '';
      this.nameInput.value = '';
      this.messageInput.value = '';
      if (this.send_onInput) {
				this.send_onInput.value = '';
				this.updateSendOnInputState();
			}
    }

		clearErrorMessage() {
      this.errorMessageWrapper.hidden = true;

      if (this.errorMessageList) this.errorMessageList.innerHTML = '';

      this.querySelectorAll('.f-recipient-fields .f-form__message').forEach(field => {
        field.classList.add('hidden');
        const textField = field.querySelector('.error-message');
        if (textField) textField.innerText = '';
      });

      [this.emailInput, this.messageInput, this.nameInput, this.send_onInput].filter(Boolean).forEach(inputElement => {
        inputElement.setAttribute('aria-invalid', false);
        inputElement.removeAttribute('aria-describedby');
      });
    }

		resetRecipientForm() {
      if (this.checkboxInput.checked) {
        // when false, we reset after ATC
        if ( this.forceAlwaysChecked == 'false' ) {
          this.checkboxInput.checked = false;
        }
        
        this.clearInputFields();
        this.clearErrorMessage();
      }
    }
	})
}